import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../services/vernost-service.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-changepassword",
  templateUrl: "./changepassword.component.html",
  styleUrls: ["./changepassword.component.css"]
})
export class ChangepasswordComponent implements OnInit {
  uid: string;
  actionmode: string = "Seacrh";
  screenTitle = "Change Password";
  namePattern;
  emailPattern;
  mobilePattern;
  screen_details: any = {};
  constructor(
    private router: Router,
    private vernostService: VernostServiceService
  ) {}

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.screen_details = {
      CURRENT_PASSWORD: "",
      NEW_PASSWORD: ""
    };
  }
  changePassWord() {
    var CURRENT_PASSWORD = this.screen_details.CURRENT_PASSWORD;
    var NEW_PASSWORD = this.screen_details.NEW_PASSWORD;

    if (
      CURRENT_PASSWORD == "" ||
      CURRENT_PASSWORD == null ||
      NEW_PASSWORD == "" ||
      NEW_PASSWORD == null
    ) {
      document.getElementById("ErrorDiv").innerHTML =
        "Please fill Current Password and New Password";
      document.getElementById("ErrorDiv").style.color = "red";
    } else {
      document.getElementById("ErrorDiv").innerHTML = "";
      document.getElementById("ErrorDiv").style.color = "";
      if (CURRENT_PASSWORD == NEW_PASSWORD) {
        document.getElementById("ErrorDiv").innerHTML =
          "Current Password and New Password Should not be Same";
        document.getElementById("ErrorDiv").style.color = "red";
      } else {
        document.getElementById("ErrorDiv").innerHTML = "";
        document.getElementById("ErrorDiv").style.color = "";
        var data = {
          uid: this.uid,
          CURRENT_PASSWORD: CURRENT_PASSWORD,
          NEW_PASSWORD: NEW_PASSWORD
        };
        this.vernostService.changePassWord(data).subscribe(response => {
          if (response[0].status == "passerr") {
            document.getElementById("ErrorDiv").innerHTML = response[0].message;
            document.getElementById("ErrorDiv").style.color = "red";
          }
          if (response[0].status == "failed") {
            document.getElementById("ErrorDiv").innerHTML = response[0].message;
            document.getElementById("ErrorDiv").style.color = "red";
          }
          if (response[0].status == "success") {
            document.getElementById("ErrorDiv").innerHTML = response[0].message;
            document.getElementById("ErrorDiv").style.color = "green";
            // this.router.navigate(['/changePassword']);
          }
        });
      }
    }
  }
  closeButton() {
    this.router.navigate(["/navigation/home"]);
  }
}
